import * as types from '../../constants/ActionTypes'

const initialState = {
  pending: false,
}

const deviceAuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.DEVICE_AUTH_REQUEST:
      return {
        ...state,
        pending: true,
      }
    case types.DEVICE_AUTH_SUCCESS:
    case types.DEVICE_AUTH_FAILURE:
      return {
        ...state,
        pending: false,
      }
    default:
      return state
  }
}

export default deviceAuthReducer



// WEBPACK FOOTER //
// ./src/redux/modules/deviceAuth.ts